import { Loader2 } from 'lucide-react';

/** Centered list/detail load indicator — matches pre-transition Drafts UX. */
export function FirestoreLoadingSpinner({ className = '' }: { className?: string }) {
  return (
    <div className={`flex min-h-full w-full items-center justify-center p-8 ${className}`.trim()}>
      <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden />
    </div>
  );
}
